import React, { useState, useEffect } from "react";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Data } from "../e_service/e_service"
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {Skeleton} from '@material-ui/lab';
import { commonService } from "../../../../services";

const useStyles = makeStyles((theme) => ({
    colore: {
        color: theme.palette.eTertiary?.base + " !important",
        fontWeight:"bold",
        fontsize:"1rem"
    },
    card:{
        margin: "2px", marginTop: "15px",padding:"12px"
    },
    uomStyles:{
        fontWeight:"bold",
        fontsize:"1rem"
    },
    uomStyle:{
        color: theme.palette.ePrimary?.base + " !important",
        fontWeight:"bold",
    },
    dateTimeStyles:{
        fontWeight:"500",
    },
    Typomargin:{
        marginTop: "4px", padding: "8px"
    },
    padd:{
        padding: "10px"
    },
    alignBottomLine:{
        paddingTop:"5px"
    },
    meterlogo:{margin:'0 auto'},
    meterimg:{marginTop:'1rem'}
}));

export default function E_MeterReadsData(data) {
    const {t:labels, ready: labelReady} = useTranslation("label-E_METER_READS")   
    const useStyleClasses = useStyles();
    const [date, setDate] = useState();
    const [startDate,setStart] = useState()
    const [endDate,setEnd] = useState()
    const [MeterImage, setMeterImage] = useState("");
    const[showMeter,setShowMeter] = useState(false);
    let result = data?.data;
    let dateTimeFormat = useSelector((state)=>state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_TIME_FORMAT)
    let meterInfo = data?.data?.getRealTimeMeterReads?.spDeviceConfigurationInfo
    let color = useSelector(
        (store) => store?.parametersWidgets?.ParameterLookup?.TERTIARY_COLOR_3
    );
    let meterLogo = useSelector(
        (store) => store?.parametersWidgets?.ParameterLookup?.E_METER_READS_IMAGE
    );
    useEffect(() => {
        if(data?.startDate && data?.endDate) {
           setStart(moment(data?.startDate, "YYYY-MM-DD-hh:mm:ss"));
           setEnd(moment(data?.endDate, "YYYY-MM-DD-hh:mm:ss"));
           setDate(moment(data?.startDate, "YYYY-MM-DD-hh:mm:ss"));
        }else {
            setDate(null);
            setStart(null)
            setEnd(null)
        }
    }, [data?.startDate, data?.endDate])

    useEffect(() => {
        if (meterLogo) {
            commonService.getAssestUrl(meterLogo).then((response) => {
                setMeterImage(response);
            })
            .catch((err) => {
                setMeterImage("");
            })
        }
    }, [meterLogo]);

    useEffect(()=>{
        if(result && result?.length==1){
            setShowMeter(true)
        }else{
            setShowMeter(false)
        }
    },[result])

    const getvalue =(value)=>{
        if(parseInt(value)){
            let round=parseFloat(value).toFixed(3)
            round=parseFloat(round).toPrecision()
            return round
        }
        else{
            return 0;
        }
    }
    let dateandtime=date && moment(date).format(dateTimeFormat).split(',')
    let sDate = date && moment(startDate).format(dateTimeFormat).split(',')
    let eDate = date && moment(endDate).format(dateTimeFormat).split(',')
    console.log(result,result?.length,"PPPPPPPPPPPPP")
    return (
        <div >
            <Grid
                container
                spacing={2}
                direction="row"
                justify="flex-center"
                alignItems="flex-center"

            >
                {result && result.map((item) => (
                    <Grid item xs={12} sm={12} md={12} className={useStyleClasses.padd} >
                        <Card className={useStyleClasses.card}>
                            <Grid container direction="row">
                                {
                                    item?.TouList.map((tou) => (
                                        <>
                                            <Grid item xs={12} sm={12} md={4} className={useStyleClasses.Typomargin}>
                                                <Typography variant="h6" align="end" className={useStyleClasses.uomStyles}>{tou?.tou}</Typography>
                                            </Grid>
                                            <Grid container  item xs={12} sm={12} md={12} >
                                            <Typography variant="subtitle2" className={useStyleClasses.dateTimeStyles}>{labelReady?labels("E_METER_READS_UOM_" + item?.uom + "_LABEL"):""} {labelReady?labels("E_METER_READ_FROM"):""} <span className={useStyleClasses.uomStyle}>{sDate && sDate[0]} {sDate && sDate[1]}</span> {labels("E_METER_READ_TO")} <span className={useStyleClasses.uomStyle}>{eDate && eDate[0]} {eDate && eDate[1]}</span> {labels("E_METER_READS_IS")} <span className={useStyleClasses.colore}>{getvalue(tou?.quantity)} {labelReady ? labels("E_METER_READS_UOM_" + item?.uom):""}</span></Typography>
                                            </Grid>
                                        </>
                                        
                                    ))
                                }
                                {
                                    item?.quantitydata && 
                                        <>
                                            <Grid item xs={12} sm={12} md={4} className={useStyleClasses.Typomargin}>
                                                <Typography variant="subtitle1" align="end" className={useStyleClasses.uomStyles}>{item?.uom}</Typography>
                                            </Grid>
                                            <Grid container  item xs={12} sm={12} md={8} >
                                                <Grid container alignItems="center" direction="row" >
                                                    <Typography variant="h5" className={useStyleClasses.colore} >{getvalue(item?.quantitydata)}</Typography>
                                                    &nbsp; &nbsp; 
                                                    <Typography variant="subtitle1" align="end" className={[useStyleClasses.uomStyles,useStyleClasses.alignBottomLine]}>{labelReady ? labels("E_METER_READS_UOM_" + item?.uom):<Skeleton/>}</Typography>
                                                </Grid>
                                            </Grid>
                                        </>
                                }
                            </Grid>
                        </Card>
                    </Grid>
                ))}
                <div className={useStyleClasses.meterlogo}>
                    {showMeter && meterLogo && (MeterImage && (
                        <img className={useStyleClasses.meterimg}
                            height="150px"
                            src={MeterImage?.assetPath}
                        />
                    ))}
                </div>
            </Grid>
        </div>
    )
}
